/**
 * Convert a key-value object to a react-select option list
 * @param {Object} obj key-value object, where
 *  key is the value of an option
 *  value is the label of an option
 * @param {Array} disabledKeyList defines which option would be disabled\
 * each item in the array should hold the key value of an option
 * @description it works with react-select component
 */
export const fromObject = (obj, disabledKeyList) => {
    return Object.entries(obj).map((entry) => {
        const [code, desc] = entry;
        return { value: code, label: desc, disabled: disabledKeyList ? disabledKeyList.includes(code) : false };
    });
}

/**
 * Convert an array to a react-select option list
 * @param {Array} arr 
 */
export const fromArray = (arr) => {
    return arr.map((elem) => {
        return { value: elem, label: elem };
    });
}